(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("simple-globe", [], factory);
	else if(typeof exports === 'object')
		exports["simple-globe"] = factory();
	else
		root["simple-globe"] = factory();
})(self, function() {
return 